import { z } from "zod";

export const getTourWaveParamSchema = z.object({
	tourWaveId: z.uuid(),
});

export type GetTourWaveParamSchema = z.infer<typeof getTourWaveParamSchema>;
